import React from 'react';

interface Props { activo: boolean; onChange: (activo: boolean) => void; disabled?: boolean; }

const PermissionStatusControl: React.FC<Props> = ({activo, onChange, disabled = false}) => (
    <div style={{background:'#f8fafc', border:'1.5px solid #f1f5f9', borderRadius:14, padding:'14px 16px', display:'flex', alignItems:'center', justifyContent:'space-between', gap:16}}>
        <div>
            <p style={{fontSize:'.82rem', fontWeight:700, color:'#0f172a', marginBottom:2}}>Estado de la ruta</p>
            <p style={{fontSize:'.7rem', color:activo ? '#8b3fa8' : '#94a3b8', fontWeight:600}}>{activo ? '● Activo' : '○ Inactivo'}</p>
        </div>
        <button type="button" role="switch" aria-label="Estado de la ruta" aria-checked={activo} disabled={disabled} onClick={() => onChange(!activo)}
            style={{width:44, minWidth:44, height:24, padding:0, border:0, borderRadius:100, background:activo ? '#61257b' : '#d1d5db', position:'relative', cursor:disabled ? 'default' : 'pointer', transition:'background .25s', flexShrink:0, opacity:disabled ? .6 : 1}}>
            <span style={{position:'absolute', top:3, left:activo ? 23 : 3, width:18, height:18, borderRadius:'50%', background:'#fff', boxShadow:'0 1px 4px rgba(0,0,0,.2)', transition:'left .25s'}} />
        </button>
    </div>
);
export default PermissionStatusControl;
